import {
  post,
  get,
  post_OSS,
  post_blob,
  post_arraybuffer,
  post_query,
} from "@/axios";
/**
 * 出库/国际发货-----------------------------------------------------------------------------------------
 * **/
/**
 * 发货任务分页 uri: /wms/delivery/task/page
 * 综合接口
 * @params: {deliveryTaskCode: String, shopName: Sting, canDelivery: Number, singleProduct: Number, createEndTime: Sting, createStartTime: Sting}
 * deliveryTaskCode: 发货任务编号
 * shopName: 店铺名称
 * canDelivery: 是否可发货(0:不可发货 1:可发货)
 * singleProduct: 是否单品(0:多品 1:单品)
 * createStartTime: 创建开始时间
 * createEndTime: 创建结束时间
 * **/
export const shipTask = function (params) {
  return post("/wms/delivery/task/page", params);
};

/**
 * 创建拣货任务前置
 * deliveryTaskCodes,pickType
 * **/
export const pagePickingTaskNotListed = function (params) {
  return post("/wms/delivery/pick/pagePickingTaskNotListed", params);
};

/**
 * 创建拣货任务
 * @params: {deliveryTaskCodeList: Array, pickType: Number}
 * deliveryTaskCodeList: 发货任务编号集合
 * pickType: 拣货类型(0:大件 1:小件单品 2:小件多品 5:国内发货)
 * **/

export const createPickTask = function (params) {
  return post("/wms/delivery/pick/task/create", params);
};

/**
 * 获取用户店铺
 * @params: {}
 * **/

export const getShopList = function (params) {
  return post("/customer/customer/shop/list", params);
};

/***
 * 通过发货编号获取发货任务信息
 * */
export const taskCodeGetInfo = function (params) {
  return get("/wms/delivery/task/info/b2b", params);
};

/**
 * 达标完成
 * **/

export const finishMark = function (params) {
  return post("/wms/delivery/task/mark/finish", params);
};

/**
 * 获取小件单品打包详情
 * **/

export const getSmallBagSingleDetail = function (params) {
  return get("/wms/delivery/task/info/d2c/single", params);
};

/**
 * 获取小件多品打包详情
 * **/

export const getSmallBagMultiDetail = function (params) {
  return get("/wms/delivery/task/info/d2c/more", params);
};

/**
 *
 * 小件打包称重 set
 *
 * **/

export const setSmallBagWeight = function (params) {
  return post("/wms/delivery/task/logistics/d2c/weight/edit", params);
};

/**
 *
 * --发货容器列表 通用（打包、小包）
 *
 * **/

export const getLogisticsInfoList = async function (params) {
  if (!params?.deliveryTaskCode) return {}
  return get("/wms/delivery/task/logistics/detail/list", params);
};
/**
 *
 * --发货容器编辑（大包、小包： 新增容器、编辑物流单号）
 *
 * **/

export const setLogisticstInfo = function (params) {
  return post("/wms/delivery/task/logistics/edit", params);
};

/**
 *
 * --编辑发货容器的箱子（新增、编辑）
 *
 * **/

export const setContainerBoxInfo = function (params) {
  return post("/wms/delivery/box/edit", params);
};

/**
 *
 * 切换物流备选渠道
 *
 * **/
export const switchBackupLogisticsChannel = function (params) {
  return post("/wms/delivery/task/logistics/switchBackupLogisticsChannel", params);
};

/**
 *
 * --删除发货容器的箱子（删除）
 *
 * **/

export const delContainerBox = function (params) {
  return post("/wms/delivery/box/delete", params);
};

/**
 *
 * --编辑箱子内商品数量（数量为 0， 就是删除）
 *
 * **/

export const setProductNums = function (params) {
  return post("/wms/delivery/box/product/edit", params);
};

/**
 *
 * --编辑箱子内商品数量（数量为 0， 就是删除）
 *
 * **/

export const setProductNumsV2 = function (params) {
  return post("/wms/delivery/box/product/edit/v2", params);
};

/**
 *
 * --编辑箱子内商品数量（数量为 0， 就是删除）--优化
 *
 * **/

export const setProductNumsWithPkg = function (params) {
  return post("/wms/delivery/box/product/editWithPkg", params);
};

/**
 * 发货箱可复制最大数量
 */
export const boxCopyMaxAmount = function (params) {
  return post("/wms/delivery/box/copy/maxAmount", params);
};

/**
 * 大件批量复制
 */
export const boxBigBatchCopy = function (params) {
  return post("/wms/delivery/box/big/batchCopy", params);
};

/**
 * FBA批量复制
 */
export const boxFbaBatchCopy = function (params) {
  return post("/wms/delivery/box/fba/batchCopy", params);
};

/**
 * 打包完成 通用 (打包、小包)
 * **/

export const finishBuildBag = function (params) {
  return post("/wms/delivery/task/pack/finish", params);
};

/**
 * 分拣蓝列表
 * **/

export const basketList = function () {
  return get("/wms/basket/list");
};

/**
 * 确认发货
 * **/

export const confirmDelivery = function (params) {
  return post("/wms/delivery/task/confirm/delivery", params);
};

/**
 * 确认发货
 * **/

export const getCustomerShopListApi = function (params) {
  return get("/customer/customer/shop/query", params);
};

/**
 * 批量导出发货
 * **/

export const exportDeliveryTask = function (params) {
  return post_blob("/wms/delivery/task/exportDeliveryTask", params);
};

/**
 * 一键获取物流单号
 * **/

export const getLogisticsNo = function (params) {
  return post("/wms/delivery/task/getLogisticsNo", params);
};
/**
 * 批量获取物流单号
 * **/

export const batchGetLogisticsNo = function (params) {
  return post("/wms/delivery/task/batchGetLogisticsNo", params);
};

/**
 * 批量获确认发货
 * **/

export const batchConFirmDeliery = function (params) {
  return post("/wms/delivery/task/confirm/batch/delivery", params);
};

/**
 * 修改申报信息
 * **/

export const modifyCustoms = function (params) {
  return post("/wms/delivery/task/modifyCustoms", params);
};

/**
 * 修改物流信息
 * **/

export const changeLogistics = function (params) {
  return post("/wms/delivery/task/modifyLogisticsCompany", params);
};

/**
 * 获取渠道
 * **/

export const getChannel = function (params) {
  return get("/wms/delivery/task/getChannel", params);
};
/**
 * 获取箱子列表
 * **/

export const getBox = function (params) {
  return get("/wms/box/list", params);
};

/**
 * 修改渠道
 * **/

export const changeChannel = function (params) {
  return post("/wms/delivery/task/modifyChannel", params);
};

/**
 * 发货单备注
 * **/

export const taskRemark = function (params) {
  return post("/wms/delivery/task/remark", params);
};

/**
 * 商品备注
 * **/

export const skuRemark = function (params) {
  return post("/wms/delivery/task/skuRemark", params);
};
/**
 * 下载发货单详情
 * **/

export const b2bExportDeliveryTask = function (params) {
  return post_blob("/wms/delivery/task/b2bExportDeliveryTask", params);
};
/**
 * 下载装箱清单
 * **/

export const downloadPackingList = function (params) {
  return post_blob("/wms/delivery/task/wmsDownloadPackingList", params);
};
/**
 * 下载箱子规格excal
 * **/

export const downloadcarton = function (params) {
  return post_blob("/wms/delivery/task/download/carton/info/excel", params);
};
/**
 * 同步箱唛 下载
 * **/

export const boxMarkLink = function (params) {
  return post("/wms/delivery/task/get/boxMarkLink", params);
};
/**
 * 更新信息至亚马逊
 * **/

export const uploadDataToAmazon = function (params) {
  return post("/wms/delivery/task/uploadDataToAmazon", params);
};
/**
 * 上传excel
 * **/

export const uploadExccel = function (params) {
  return post_OSS("/api/inbound/upload/carton/size/info", params);
};

//批量获取运单号 ———————— 新

export const batchEditLogisticsNo = function (params) {
  return post("/wms/delivery/task/batchEditLogisticsNo", params);
};

//获取打印标签模板

export const printListByType = function (params) {
  return get("/wms/print/listByType", params);
}; //获取打印标签模板

export const listPkgDetail = function (params) {
  return post("/wms/pkg/listPkgDetail", params);
};
//skuinfo

export const skuInfo = function (params) {
  return get("/wms/delivery/task/skuInfo", params);
};

//修改重量
export const editWeight = function (params) {
  return post("/wms/delivery/box/editWeight", params);
};
//批次包详情
export const pkgDetail = function (params) {
  return get("/wms/pkg/pkgDetail", params);
};
//修改货代公司
export const modifyForwarder = function (params) {
  return post("/wms/delivery/task/modifyForwarder", params);
};
//查询所有货代公司
export const forwarderList_outStock = function (params) {
  return get("/settlement/intForwarderConfig/getWithIntShipConfig", params);
};

//更新报关信息
export const goodsFeign = function (params) {
  return post("/goods/product/skus/byProductSkuList/customer/feign", params);
};

//更新报关信息 新
export const goodsFeign_new = function (params) {
  return post("wms/delivery/task/renewCustoms", params);
};

//下载装箱清单--客户上传的文件
export const downloadCustomerPackingListFile = function (params) {
  return post("/wms/delivery/task/downloadCustomerPackingListFile", params);
};

//下载箱唛--客户上传的文件
export const downloadCustomerBoxMarkFile = function (params) {
  return post("/wms/delivery/task/downloadCustomerBoxMarkFile", params);
};

//<<<<<<<<<<<<<<<<<<<<<审单<<<<<<<<<<<<<<<<<<<<<<<<
//国际发货审单  分页
export const deliveryReviewPage = function (params) {
  return post("/wms/deliveryReview/page", params);
};
//国际发货审单  更新申报信息
export const updateDeclarationInfo = function (params) {
  return post("/wms/deliveryReviewDetail/updateDeclarationInfo", params);
};
//国际发货审单  审单信息
export const reviewInfo = function (params) {
  return post("/wms/deliveryReview/reviewInfo", params);
};
//国际发货审单  审单
export const singleReview = function (params) {
  return post("/wms/deliveryReview/singleReview", params);
};
//国际发货审单  批量审单
export const batchReview = function (params) {
  return post("/wms/deliveryReview/batchReview", params);
};
//国际发货审单 审单货代列表
export const getClientForwarder = function (params) {
  return post("wms/deliveryReview/getClientForwarder", params);
};
//国际发货审单 小包列表审单 改货代
export const modifyReviewForwarder = function (params) {
  return post("wms/deliveryReview/modifyReviewForwarder", params);
};
//发货审单-批量更新申报信息
export const batchUpdateDeclarationInfo = function (params) {
  return post("wms/deliveryReviewDetail/batchUpdateDeclarationInfo", params);
};
//发货审单-批量导出
export const exportDeliveryReview = function (params) {
  return post_blob("wms/deliveryReview/exportDeliveryReview", params);
};
//发货审单-批量更换货代验证
export const getReviewForwarder = function (params) {
  return post("wms/deliveryReview/getReviewForwarder", params);
};
//发货审单-批量修改货代公司接口和异常信息--并提交
export const batchEditAndSubmit = function (params) {
  return post("/wms/deliveryReview/batchEditAndSubmit", params);
};

/**
 * 国际发货拆弹
 * **/
//查询拆包信息
export const splitOrder_selectPackage = function (params) {
  return post("/wms/delivery/splitOrder/selectPackage", params);
};
//查询剩余未打包明细
export const splitOrder_getUnpackSku = function (params) {
  return post("/wms/delivery/splitOrder/getUnpackSku", params);
};
//新增包裹
export const splitOrder_createPackage = function (params) {
  return post("/wms/delivery/splitOrder/createPackage", params);
};
//删除包裹
export const splitOrder_removePackage = function (params) {
  return post("/wms/delivery/splitOrder/removePackage", params);
};
//包里加商品
export const splitOrder_addSku = function (params) {
  return post("/wms/delivery/splitOrder/addSku", params);
};
//包里删商品
export const splitOrder_removeSku = function (params) {
  return post("/wms/delivery/splitOrder/removeSku", params);
};
//包里删商品
export const splitOrder_editWeight = function (params) {
  return post("/wms/delivery/splitOrder/editWeight", params);
};
//确认拆包
export const splitOrder_confirmSplit = function (params) {
  return post("/wms/delivery/splitOrder/confirmSplit", params);
};
//查询子发货单物流明细
export const splitOrder_detail = function (params) {
  return post("/wms/delivery/splitOrder/getLogisticsDetail", params);
};
//查询发票列表
export const getInvoicePage = function (params) {
  return post("/wms/deliveryTask/invoice/page", params);
};
//批量制作发票
export const makeInvoiceCommit = function (params) {
  return post_arraybuffer("/wms/deliveryTask/invoice/commit", params);
};
//发票下载
export const downloadInvoice = function (params) {
  return post_arraybuffer("/wms/deliveryTask/invoice/downloadInvoice", params);
};
// 查询发票模版
export const getTemplate = function (params) {
  return get("/wms/deliveryTask/invoice/getTemplate", params);
};

/**
 * 导出
 * **/
//发起导出任务
export const asyncExport = function (params) {
  return post("/wms/delivery/task/asyncExport", params);
};

/**
 * 导出OCS面单
 * **/
export const downloadOcsLabel = function (params) {
  return post("/wms/delivery/task/logistics/downloadOcsLabel", params);
};



/**
 * 导出
 * **/
//批量下载问题商品
export const batchExportNoDeclaratioSku = function (params) {
  return post("/wms/delivery/task/noDeclaratioSku/batchExport", params);
};

//导出任务列表
export const export_list = function (params) {
  return post("/wms/export/page", params);
};

//日志
export const listDeliveryTaskOperation = function (params) {
  return get("/wms/deliveryTaskOperation/listDeliveryTaskOperation", params);
};

//创建国际发货操作记录
export const createDeliveryTaskOperation = function (params) {
  return post("/wms/deliveryTaskOperation/create", params);
};

//一键重新获取物流单号
export const getAgainLogisticsNo = function (params) {
  return post("/wms/delivery/task/getAgainLogisticsNo", params);
};

//单证优化
//上报异常接口
export const abnormalCommit = function (params) {
  return post("/wms/deliveryReview/abnormal/commit", params);
};
//异常列表-根据SKU编辑
export const abnormalCommit_sku = function (params) {
  return post("/wms/deliveryReview/abnormal/sku/edit", params);
};
//异常列表-根据SPU编辑
export const abnormalCommit_spu = function (params) {
  return post("/wms/deliveryReview/abnormal/spu/edit", params);
};
//异常列表-申报商品材质接口查询接口
export const compilationMethodPage = function (params) {
  return post(
    "/wms/deliveryReview/product/customs/compilationMethod/page",
    params
  );
};
//异常列表-申报商品接口查询接口
export const customsPage = function (params) {
  return post("/wms/deliveryReview/product/customs/page", params);
};
//异常列表-申报商品提交接口
export const customsConfirm = function (params) {
  return post("/wms/deliveryReview/product/customs/confirm", params);
};
//异常列表-审核原因枚举接口
export const auditReasonList = function (params) {
  return post("/wms/deliveryReview/auditReason/list", params);
};
//异常列表-组合商品子商品
export const combinationProduct = function (params) {
  return post("/wms/deliveryReview/combination/product/list", params);
};
//异常列表-批量编辑货代公司接口和异常信息
export const reviewBatchEdit = function (params) {
  return post("/wms/deliveryReview/batchEdit", params);
};
//发票-货代渠道列表 带计数
export const getInvoiceForwarder = function (params) {
  return post("/wms/deliveryTask/invoice/getInvoiceForwarder", params);
};
//发票-货代公司列表 带计数
export const getForwarderCompany = function (params) {
  return post("/wms/deliveryTask/invoice/getForwarderCompany", params);
};
//发票-下载装箱清单
export const downloadInvoicePackingList = function (params) {
  return post_blob("/wms/deliveryTask/invoice/downloadPackingList", params);
};
//发票-导出
export const invoiceExport = function (params) {
  return post("/wms/deliveryTask/invoice/export", params);
};

//国际发货单-导出下载没有申报信息的SKU数据
export const noDeclaratioSkuExport = function (params) {
  return post_blob("/wms/delivery/task/noDeclaratioSku/export", params);
};

//发货单页面查货代
export const taskGetForwarder = function (params) {
  return get("/wms/delivery/task/logistics/getForwarder", params);
};

//国际发货单-获取收货国家列表
export const taskCountryList = function (params) {
  return post("/wms/delivery/task/country/list", params);
};

//国际发货单-生成销售合同
export const generateSalesContract = function (params) {
  return post_blob("/wms/deliveryTask/invoice/generateSalesContract", params);
};

//可制发票列表-线下制作 状态更新
export const offlineCommit = function (params) {
  return post("/wms/deliveryTask/invoice/offlineCommit", params);
};

//国际发货单 附加项列表
export const getAdditionalDetails = function (params) {
  return post("/wms/delivery/task/getAdditionalDetails", params);
};

//获取客户信息
export const getCUstomerInfo = function (params) {
  return post("/customer/getAllMainCustomer");
};

//新建波次
export const waveCreate = function (params) {
  return post("/wms/delivery/wave/create", params);
};

//波次列表
export const wavePage = function (params) {
  return post("/wms/delivery/wave/page", params);
};

//波次列表
export const waveForwarder = function (params) {
  return post("/wms/delivery/wave/forwarder/list", params);
};

//波次详情
export const waveDetail = function (params) {
  return get("/wms/delivery/wave/detail", params);
};

//波次-查询客户可待发货发货单数量
export const waveDeliveryTaskAmount = function (params) {
  return post("/wms/delivery/wave/customer/deliveryTaskAmount", params);
};

//波次-批次数量查询
export const waveMatchAnalysis = function (params) {
  return post("/wms/delivery/wave/match/analysis", params);
};

//拣货批次-批次包详情
export const getPickByBatchCode = function (params) {
  return post("/wms/delivery/pick/batch/pkg/getByBatchCode", params);
};

//波次-取消
export const waveCancel = function (params) {
  return post_query("/wms/delivery/wave/cancel", params);
};

//波次-根据子容器获取详情
export const getByContainerCode = function (params) {
  return get("/wms/delivery/task/info/d2c/more/getByContainerCode", params);
};

//波次-小件单品打包-校验批次包是否有多容器
export const singleCheck = function (params) {
  return post("/wms/delivery/task/info/d2c/single/check", params);
};

//发货商品抵扣明细
export const deliverySkuDeductionRecord = function (params) {
  return get("/wms/deduction/deliverySkuDeductionRecord", params);
};

//发货任务详情
export const deliveryTaskInfo = function (params) {
  return get("/wms/delivery/task/info", params);
};

//发货任务分页-新
export const deliveryTaskPage = function (params) {
  return post("/wms/delivery/task/taskPage", params);
};

//根据国际发货单号获取货箱物流明细
export const batchGetLogistics = function (params) {
  return post("/wms/delivery/task/logistics/box/getLogistics", params);
};

//编辑国际发货单发货箱物流单号
export const batchEditLogistics = function (params) {
  return post("/wms/delivery/task/logistics/box/logistics/edit", params);
};

//大件打标新增操作记录
export const createMarkOperation = (params) => {
  return post(`/wms/deliveryTaskOperation/createMarkOperation`, params);
};

// zozotown模板
export const getZozotownTemplate = function (params) {
  return get('/wms/delivery/task/getTagTemplate', params)
}

//下载纳品书
export const downloadPackingDetailsFile = function (params) {
  return post_arraybuffer('/wms/delivery/task/downloadPackingDetailsFile', params)
}

//删除发货-容器
export const deleteLogisticsTask = (params) => {
  return post(`/wms/delivery/task/logistics/delete`, params);
};

//编辑附加项实际操作数
export const editOperand = (params) => {
  return post(`/wms/delivery/addition/editOperand`, params);
};

//打包完成 确认附加项
export const packFinishConfirm = (params) => {
  return post(`/wms/delivery/task/pack/finish/confirm?deliveryTaskCode=${params.deliveryTaskCode}`);
};

//国际发货单废弃
export const abandonDeliveryTask = (params) => {
  return post(`/wms/delivery/task/abandonDeliveryTask`, params);
};

//获取国家
export const getCountryListApi = (params) => {
  return get(`/customer/getAreaByLevelOnly`, params);
};

//更新小包发票基础配置
export const updateD2cBaseConfig = (params) => {
  return post(`/wms/deliveryTask/invoice/updateD2cBaseConfig`, params);
};

//获取小包发票基础配置
export const getD2cBaseConfig = (params) => {
  return get(`/wms/deliveryTask/invoice/getD2cBaseConfig`, params);
};

//小包发票已制作分页
export const d2cHasMadePage = (params) => {
  return post(`/wms/deliveryTask/invoice/d2cHasMadePage`, params);
};

export const getAdditionList = () => {
  return get(`/wms/pkg/getAdditionList`)
}
// 退回待制作
export const returnBackPlayApi = (params) => {
  return post(`/wms/deliveryTask/invoice/fallback`, params);
};

// 手动制作小包发票
export const batchCreateInvoiceApi = (params) => {
  return post(`/wms/deliveryTask/invoice/makeD2cInvoice`, params);
};

// 审单回退
export const deliveryReviewApi = (params) => {
  return post(`/wms/deliveryReview/rollback`, params);
};

//获取开放页面链接
export const getWangWangInternationalUrlApi = (params) => {
  return get(`/automation/page/link/get`, params);
};

// 运输属性列表
export const getTransportationAttributesListApi = (params) => {
  return post(`/settlement/transportationAttributes/list`, params);
};

// 获取旺旺url
export const getWangWangUrlApi = (params) => {
  return post(`/goods/supplierShop/getShopCustomerServiceId`, params);
};

// 发货审单-更新商品运输属性
export const updateSkuTransportationAttrApi = (params) => {
  return post(`/wms/deliveryReviewDetail/updateSkuTransportationAttr`, params);
};

// 发货审单-更新商品运输属性
export const checkAbnormalDeliveryReviewApi = (params) => {
  return post(`/wms/deliveryReview/check/allChange/abnormal`, params);
};
// 翻译
export const getTranslateApi = (params) => {
  return post(`/goods/translate/common`, params);
};

// 分页列表
export const supplierManageQueryApi = (params) => {
  return post(`/goods/supplier/manage/query`, params);
};

// 批量更新中文品名
export const batchUpdateProductItemCategoryZhApi = (params) => {
  return post(`/wms/deliveryReviewDetail/batchUpdateProductItemCategoryZh`, params);
};

// 采购管理 - 报关管理 - 报关信息列表
export const customsListApi = params => {
  return post("/goods/product/customs/list", params);
};


//获取组合子商品
export const getCombinationItemListApi = (params) => {
  return get(`/wms/deliveryReview/getCombinationItem`, params);
};

// 新增商品报关编码
export const insertCustomsApi = params => {
  return post("/wms/deliveryReviewDetail/insertCustoms", params);
};



// 新增商品报关编码
export const updateStatusApi = params => {
  return get("/wms/delivery/task/check/fba/updateStatus", params);
};

// 获取可打包爆品任务
export const getHotPackingListApi = params => {
  return get("/wms/delivery/explosive/product/getEnablePackTasksByPkg", params);
};
// 批量更新重量
export const batchUpdateHotWeightApi = params => {
  return post("/wms/delivery/explosive/product/batch/update/weight", params);
};

// 批量打包完成
export const batchPackFinishApi = params => {
  return post("/wms/delivery/explosive/product/batch/pack/finish", params);
};
// 拣货完成（线下）
export const pickFinishApi = params => {
  return post("/wms/delivery/task/pickFinish", params);
};
// 下载拣货任务
export const downloadPickTaskApi = params => {
  return post_arraybuffer("/wms/delivery/task/downloadPickTask", params);
};
/** FBA-箱唛顺序校验 */
export const fbaCheckBoxMark = params => {
  return post("/wms/delivery/task/fbaCheckBoxMark", params);
};

/** 获取海外仓箱唛 */
export const getOverseasBoxCodeApi = params => {
  return get("/wms/delivery/box/getBoxMarkCode", params);
};

// 移入已拦截
export const removeInterceptApi = params => {
  return post("/wms/delivery/task/moveIntercept", params);
};

/** 小包制作发票退回 */
export const d2cFallbackApi = params => {
  return post("/wms/deliveryTask/invoice/d2cFallback", params);
};
